// extracted by mini-css-extract-plugin
module.exports = {"heading":"HeaderDoc_heading__nu9Yu","description":"HeaderDoc_description__eCoGl"};